import React, { useState, useContext, useEffect } from "react";
import InicioContext from "./InicioContext";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import {
  BsList,
  BsHouseDoor,
  BsBook,
  BsSearch,
  BsLightbulb,
} from "react-icons/bs";
import { GrFormClose } from "react-icons/gr";
import { MdOutlineAccountCircle, MdExitToApp } from "react-icons/md"; // Importe os ícones da biblioteca
import "./styles/Nav.css";

function Nav() {
  const data = useContext(InicioContext);
  const dataToken = useContext(AuthContext);
  const [logged, setLogged] = useState(false);

  const { HoldPage, Enter, BookInformations, titlesDefine, inicio, setPage } =
    data;

  const { token, backEnd } = dataToken;

  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  useEffect(() => {
    tokenVerification();
  }, []);
  function tokenVerification(event) {
    fetch(backEnd + "/", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.response === "200") {
          setLogged(true);
          if (event.target.id === "livros") {
            navigate("/catalogo");
          } else if (event.target.id === "perfil") {
            navigate("/perfil");
          }
        } else {
          setLogged(false);
          if(event.target.id){
            navigate("/login");
          }
          
        }
      })
      .catch((error) => {
        console.error("Error checking user authentication:", error);
      });
  }
  function Clear(event) {
    setPage("");
    HoldPage("");
    const inputElement = document.querySelector(".bookInput");
    if (inputElement) {
      inputElement.value = "";
      var cleanedInput = cleanInput(inputElement.value);
      // eslint-disable-next-line no-inner-declarations
      function cleanInput(input) {
        const trimmedInput = input.trim();
        cleanedInput = trimmedInput.replace(/[^\w\s]/gi, "");
        return cleanedInput;
      }
    }
    event.preventDefault();
  }

  return (
    <form className="nav">
      <h1 className="divHeader">
        <i className="fa-solid fa-meteor"></i>
        Book Flow
      </h1>

      <div className="SearchBar">
        <div className="Search">
          <button className="enterSearch" onClick={Enter} type="submit">
            <BsSearch />
          </button>
          <input
            className="bookInput"
            type="text"
            onChange={HoldPage}
            name="Nome do Livro"
            placeholder="Insira o Nome do Livro"
          />
          {HoldPage !== "" ? (
            <button className="deleteSearch" onClick={Clear}>
              <GrFormClose />
            </button>
          ) : null}
        </div>

        {Array.isArray(BookInformations.titles) ? (
          <div className="searchItem">
            <div>{BookInformations.titles.map(titlesDefine)}</div>
          </div>
        ) : null}
      </div>

      {/* Ícone de hamburguer */}
      <div className="hamburger-icon" onClick={toggleMenu}>
        <BsList />
      </div>

      {/* Menu de navegação */}
      <div className={`menu ${isMenuOpen ? "open" : ""}`}>
        <ul>
          <a onClick={() => navigate("/")}>
            <li id="0" onClick={inicio}>
              <BsHouseDoor size={24} />
              <span className="icon-text">Início</span>
            </li>
          </a>

          <a onClick={() => navigate("/ideias")}>
            <li>
              <BsLightbulb size={24} />
              <span className="icon-text">Ideias</span>
            </li>
          </a>
          {logged ? (
            <>
              <a id="livros" onClick={tokenVerification}>
                <li>
                  <BsBook size={24} />
                  <span id="livros" className="icon-text">
                    Livros
                  </span>
                </li>
              </a>

              <a id="perfil" onClick={tokenVerification}>
                <li>
                  <MdOutlineAccountCircle size={24} />
                  <span id="perfil" className="icon-text">
                    Minha Conta
                  </span>
                </li>
              </a>

              <a href="/">
                <li
                  className="logoutIcon"
                  onClick={() => {
                    localStorage.removeItem("token");
                    fetch("/logout", {
                      method: "GET",
                    });
                  }}
                >
                  <MdExitToApp size={24} />
                  <span className="icon-text">Sair</span>
                </li>
              </a>
            </>
          ) : <>
            
          <a id="perfil" onClick={tokenVerification}>
                <li>
                  <MdOutlineAccountCircle size={24} />
                  <span id="perfil" className="icon-text">
                    Login
                  </span>
                </li>
              </a>
          </>}
        </ul>
      </div>
    </form>
  );
}

export default Nav;
